var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menu-search" }, [
    _c("i", { staticClass: "fal fa-search menu-search-icon" }),
    _c("input", {
      staticClass: "menu-search-input",
      attrs: { placeholder: _vm.placeholder, type: "text" },
      domProps: { value: _vm.value },
      on: { input: _vm.emitValue }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }